import {
  v4,
  validate,
} from 'uuid'

export type UUID = `${'00000000-0000-0000-0000-000000000000' | string}`

export const isUuid = (str: string): str is UUID => {
  return validate(str)
}

export const uuidFromString = (str: string): UUID => {
  if (isUuid(str)) {
    return str
  }

  throw Error(`'${str}' is not a valid UUID.`)
}

export const randomUuid = (): UUID => uuidFromString(v4())
